<main class="middle-content">
    <div class="content-section">
        <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item active">
                <a routerLink="/patient-mgt">Patient Management </a>
            </li>
            <li class="breadcrumb-item">View</li>
        </ol>
        <div class="order-view mb20 max-WT-700 mrgn-0-auto">
            <div class="main-block-innner">
                <div class="add-store-block input-style mw-100">

                    <div class="form-user">
                        <form>

                            <div class="text-center mt-4 mb-5">
                                <div class="flex-block align-center">
                                    <div class="profile_block" style="position: relative">
                                        <img [src]='viewPatientData?.profilePic || "assets/img/profile-img.jpg"'
                                            class="imagePicture" alt="banner image" (error)="onImageError($event)" />
                                    </div>

                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-6 col-form-label">
                                    <h6>First Name : </h6>
                                </label>
                                <div class="col-sm-6">
                                    <label class=" col-form-label"> {{viewPatientData?.firstName}}</label>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-6 col-form-label">
                                    <h6>Last Name : </h6>
                                </label>
                                <div class="col-sm-6">
                                    <label class=" col-form-label"> {{viewPatientData?.lastName || '--'}}</label>
                                </div>
                            </div>


                            <div class="form-group row">
                                <label class="col-sm-6 col-form-label">
                                    <h6>Email : </h6>
                                </label>
                                <div class="col-sm-6">
                                    <label class=" col-form-label">{{viewPatientData?.email}}</label>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="inputPassword" class="col-sm-6 col-form-label">
                                    <h6>Phone Number : </h6>
                                </label>
                                <div class="col-sm-6">
                                    <label
                                        class="col-form-label">{{viewPatientData?.countryCode}}{{viewPatientData?.mobileNumber}}</label>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="inputPassword" class="col-sm-6 col-form-label">
                                    <h6>Therapist : </h6>
                                </label>
                                <div class="col-sm-6">
                                    <label class="col-form-label">{{viewPatientData?.myTherapist[0]?.firstName || '--'}}
                                        {{viewPatientData?.myTherapist[0]?.lastName}}</label>
                                </div>
                            </div>
                            <!-- <div id="chartContainer" style="height: 370px; width: 100%; margin-left:auto;margin-right:auto;"></div> -->
                            <!-- tab section -->
                            <div class="tab-section">
                                <div class="tab">
                                    <button class="tablinks" [ngClass]="tabView == 'SessionRequests' ? 'active': ''"
                                        (click)="viewTab('SessionRequests')">Session Requests</button>
                                    <button class="tablinks" [ngClass]="tabView == 'Assessments' ? 'active': ''"
                                        (click)="viewTab('Assessments')">Assessments</button>
                                    <button class="tablinks" [ngClass]="tabView == 'Drinkingdiary' ? 'active': ''"
                                        (click)="viewTab('Drinkingdiary')">Drinking diary</button>
                                </div>
                            </div>

                            <div class="card">
                                @if(tabView == 'SessionRequests'){
                                <div>
                                    @if(sessionListData.length){
                                    <div>
                                        @for (session of sessionListData; track session; let i = $index) {
                                        <div class="card-header">
                                            <div class="row d-flex">
                                                <div class="col-md-4">
                                                    <h5 class="card-title">Start date & time</h5>
                                                    <p>{{session.startTime}}, {{session.date | date : 'd/M/y' :'UTC'}}
                                                    </p>
                                                </div>
                                                <div class="col-md-4">
                                                    <h5>End date & time</h5>
                                                    <p>{{session.endTime}}, {{session.date | date : 'd/M/y' :'UTC'}}</p>
                                                </div>
                                                <div class="col-md-4">
                                                    <h5>Session Type</h5>
                                                    <p>{{session?.programName}} </p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12 d-flex">
                                                    <h5 class="card-title">Appointment With: &nbsp;</h5>
                                                    <p>{{session.therapistId.firstName}}
                                                        {{session.therapistId.lastName}}
                                                    </p>
                                                </div>
                                            </div>

                                            <mat-accordion>
                                                <mat-expansion-panel (opened)="panelOpenState = true"
                                                    (closed)="panelOpenState = false">
                                                    <mat-expansion-panel-header>
                                                        <mat-panel-title>
                                                            <h5 (click)="getNotesDetailsApi()"
                                                                class="text-nowrap d-flex align-items-center">
                                                                <span>Notes</span>
                                                                <i class="fa fa-chevron-circle-right ms-2"
                                                                    aria-hidden="true"></i>
                                                            </h5>
                                                        </mat-panel-title>
                                                    </mat-expansion-panel-header>
                                                    @if(viewNotesArr.length != 0){
                                                    <div class="notes_Box">
                                                        @for (notes of viewNotesArr; track notes; let i = $index) {
                                                        <div class="form-group row m-0">
                                                            <p class="m-0 w-100">
                                                                <label for="">{{notes?.createdAt | date : 'd/M/y'
                                                                    :'UTC'}}</label>
                                                            </p>
                                                            <p class="border-bottom">{{notes?.note}}</p>
                                                        </div>
                                                        }
                                                    </div>
                                                    }
                                                    @if(viewNotesArr.length == 0){
                                                    <div class="form-group row m-0">
                                                        <div class="card w-100">
                                                            <div class="card-header">
                                                                <h6 class="text-center">No notes found!</h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    }
                                                </mat-expansion-panel>
                                            </mat-accordion>
                                        </div>
                                        }
                                    </div>
                                    }
                                    @if(!sessionListData.length){
                                    <div>
                                        <div class="card-header text-center">
                                            <h5>No session found!</h5>
                                        </div>
                                    </div>
                                    }
                                </div>
                                }
                                @if(tabView == 'Assessments'){
                                <div>
                                    @if(assessmentData.length != 0){
                                    <div class="card-header col-md-12">
                                        <div class="row border-bottom">
                                            <div class="col-md-5">
                                                <label class="text-nowrap">
                                                    <h5> Assessment Name</h5>
                                                </label>
                                            </div>
                                            <div class="col-md-7 text-left">
                                                <label class="text-nowrap">
                                                    <h5> Remarks</h5>
                                                </label>
                                            </div>
                                        </div>
                                        <table style="min-width: fit-content" class="mt-3">
                                            @for (assessment of assessmentData; track assessment; let i = $index) {
                                            <tr class="mt-5 mb-2">
                                                <td class="content">
                                                    <abbr [title]="assessment?.title">
                                                        {{assessment?.title }}
                                                    </abbr>

                                                </td>
                                                <td class="text-left content">
                                                    <span class="ms-2">
                                                        <abbr [title]="assessment?.remarks">
                                                            {{assessment?.remarks}}
                                                        </abbr>
                                                    </span>
                                                </td>
                                            </tr>
                                            }
                                        </table>

                                    </div>
                                    }
                                    @if(assessmentData.length == 0){
                                    <div class="card-header text-center">
                                        <h5> Assessment data no found! </h5>
                                    </div>
                                    }
                                </div>
                                }
                                @if(tabView == 'Drinkingdiary'){
                                <div>
                                    @if(tabView == 'Drinkingdiary'){
                                    <div class="mx-4">
                                        <p class="m-0"> x-axis : Set Goal </p>
                                        <p> y-axis : Achieve Goal</p>
                                    </div>
                                    }
                                </div>
                                }
                            </div>

                            <div id="chartContainer" style="height: 300px; width: 100%;"></div>
                            <!--end tab section  -->
                        </form>

                    </div>
                    <div class="d-flex justify-content-center mt-5 mb-5">
                        <button class="btn btn-theme" routerLink='/patient-mgt'>Back</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Table Responsive End -->

</main>